import { Layout } from '@/utils/routerHelper'


const sportsMgtRouter = {
  path: '/sports-mgt',
  component: Layout,
  name: 'M_SPORTS_MGT',
  // code: 'M_SPORTS_MGT',
  meta: {
    title: '赛事管理',
    icon: 'ep:trophy',
  },
  children: [
    {
      path: 'sports-list',
      component: () => import('@/views/sports-mgt/index.vue'),
      name: 'M_SPORTS_LIST',
      meta: {
        title: '赛事列表',
        icon: 'ep:list',
        noCache: true
      }
    },
    {
      path: 'sports/:id/enroll',
      component: () => import('@/views/sports-mgt/sports-enroll.vue'),
      name: 'M_SPORTS_ENROLL',
      meta: {
        title: '裁判报名',
        hidden: true,
        canTo: true,
        activeMenu: '/sports-mgt/sports-list'
      },
    },
    {
      path: 'sports/:id/post-arrange',
      component: () => import('@/views/sports-mgt/post-arrange.vue'),
      name: 'P_POST_ARRANGE',
      meta: {
        title: '定岗',
        hidden: true,
        canTo: true,
        activeMenu: '/sports-mgt/sports-list'
      },
    },
    // {
    //   path: 'sports/:id/enroll-list',
    //   component: () => import('@/views/sports-mgt/sports-enroll-list.vue'),
    //   name: 'M_SPORTS_ENROLL_LIST',
    //   meta: {
    //     title: '报名列表',
    //     hidden: true,
    //     canTo: true,
    //     activeMenu: '/sports-mgt/sports-list'
    //   },
    // },
  ]
}

export default sportsMgtRouter
